








import { createComponent, onUnmounted } from "@vue/composition-api";

interface BaseModalProps {
  show: boolean;
  renderTo: string;
}

export default createComponent({
  props: {
    show: {
      type: Boolean,
      required: true
    },
    renderTo: {
      type: String,
      required: true
    }
  },
  setup(props: Readonly<BaseModalProps>, context) {
    const dismiss = () => {
      context.emit("close");
    };
    const escapeHandler = (e: KeyboardEvent) => {
      if (e.key === "Escape" && props.show) {
        dismiss();
      }
    };
    document.addEventListener("keydown", escapeHandler);

    onUnmounted(() => document.removeEventListener("keydown", escapeHandler));
  }
});
